import react, { CSSProperties, useState } from 'react'
import { colors, fonts } from "../../../Styles"
import { useTranslation } from 'react-i18next';
import { AttentionTypes } from '../../../Definitions/valueTypes';

import { TestData as PenData} from '../../../Assets/TestData/lf_Data';
import { TestData as AnimalData } from '../../../Assets/TestData/animalData'
import { _attentionColor } from '../../../Definitions';

interface PenAttention_Props {
  penId: number
  hasHoverEffekt?: boolean
  onClick?: () => void
}
/**
 * PEN_ATTENTION
 * @param penId Unique identifier for each pen.
 * @param hasHoverEffekt Boolean that, if true, adds a hover effect to the pen.
 * @param onClick Dynamic onClick eventhandler.
 * @returns a pen where bg color is based on attentiontype.
 */
export default function PEN_ATTENTION({ penId, hasHoverEffekt, onClick }: PenAttention_Props) {
  const {t} = useTranslation()
  const [isHovered, setIsHovered] = useState(false);

  // Find the pen and related data
  const pen = PenData.find(item => item.penId === penId)

  // Find pen attention (type)
  const penAttention = pen? pen.attention : "";

  // Assign a specific color based on pen's attention type
  const attentionColor: AttentionTypes | undefined = penAttention&&penAttention === AttentionTypes.warning || penAttention === AttentionTypes.alert ? penAttention as AttentionTypes : undefined

  // Find the pen animal and related data
  const animal = AnimalData.find(item => item.animalId === pen?.animalId);

  // Content to parse in the div
  const baseContent = 
    <>
      { animal 
        ? <span>{animal.animalId}</span>
        : <span style={{opacity: "0.5"}}>{t("locationFeeder.penPopup.emptyPen")}</span>
      }
    </>

  // Apply hover effect only if hasHoverEffekt is true
  const handleMouseEnter = () => {
    if (hasHoverEffekt && animal) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (hasHoverEffekt && animal) {
      setIsHovered(false);
    }
  };

  return (
    <div 
      onClick={animal? onClick : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ 
        width: "80px",
        height: "30px",
        cursor: hasHoverEffekt && animal? "pointer" : "",
      }}
    >
      <div style={{
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: 'center',
        alignContent: "center",
        backgroundColor: colors.greyLightSecondary,
        filter: isHovered ? 'opacity(0.5)' : 'opacity(1)',
        transition: 'filter 0.3s',
        color: colors.greyDarkPrimary,
        ...fonts.paragraph,
        ...fonts.fontSize4,
      }}>
        {baseContent}
        <div style={{top: "0", left: "0", position: "absolute", width: "10px", height: "30px", backgroundColor: _attentionColor(attentionColor)}}></div>
      </div>
    </div>
  );
}